/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SupplierDeliveryItemDTOFromJSON, SupplierDeliveryItemDTOToJSON, } from './SupplierDeliveryItemDTO';
/**
 * Check if a given object implements the SupplierDeliveryImportRequest interface.
 */
export function instanceOfSupplierDeliveryImportRequest(value) {
    if (!('orders' in value) || value['orders'] === undefined)
        return false;
    return true;
}
export function SupplierDeliveryImportRequestFromJSON(json) {
    return SupplierDeliveryImportRequestFromJSONTyped(json, false);
}
export function SupplierDeliveryImportRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orders': (json['orders'].map(SupplierDeliveryItemDTOFromJSON)),
    };
}
export function SupplierDeliveryImportRequestToJSON(json) {
    return SupplierDeliveryImportRequestToJSONTyped(json, false);
}
export function SupplierDeliveryImportRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orders': (value['orders'].map(SupplierDeliveryItemDTOToJSON)),
    };
}
